import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'
import {DateTime} from 'luxon'

/**
 * 라우터에 임의의 id query 값 추가
 * Runs when the router meta.middleware is 'set-random-id-query'
 * @param ctx
 */
export function beforeEnter(ctx: MiddlewareContext<App, RootState>) {
  const {query: {_id}} = ctx.to
  if(!_id) {
    const currentId = `${DateTime.local().toMillis()}`
    const to: any = {
      ...ctx.to,
      query: {
        ...ctx.to.query,
        _id: currentId,
      }
    }
    ctx.next(to)
    return
  }
  ctx.next()
}
